export default {
	// Config
	apiKey: "AIzaSyAxjeBilMcLZrTRY0d6YbiRc895g-CNg7Y",
  authDomain: "sassollc-mytrace.firebaseapp.com",
  projectId: "sassollc-mytrace",
  storageBucket: "sassollc-mytrace.firebasestorage.app",
  messagingSenderId: "907265363117",
  appId: "1:907265363117:web:1e66222a73080c9a87ca24"
};
